export default __webpack_public_path__ + "static/media/cases3@2x.6af3a18d.webp";